import { useMemo } from 'react';
import { Box, Text } from '@mantine/core';
import { DiffEditor } from '@monaco-editor/react';
import { useStore } from '@/store';
import { filterByFieldPaths, getDocFieldPaths } from '@/hooks';

export const UpdateDiffView = () => {
  const [orderText, syncText, entries] = useStore(
    ({ config: c, entries: e }) => [
      c.textContent,
      c.syncTextContent,
      e.getEntries(),
    ],
  );

  const fieldPaths = useMemo(() => getDocFieldPaths(entries), [entries]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
      }}
    >
      <Box
        sx={(theme) => ({
          display: 'flex',
          borderBottom: `1px solid ${theme.colors.gray[2]}`,
        })}
      >
        <Text
          size="sm"
          weight={500}
          color="dimmed"
          sx={{ flex: 1, textAlign: 'center', padding: '0.5rem' }}
        >
          Order
        </Text>
        <Text
          size="sm"
          weight={500}
          color="dimmed"
          sx={{ flex: 1, textAlign: 'center', padding: '0.5rem' }}
        >
          SyncOrder
        </Text>
      </Box>
      <Box sx={{ flex: 1, minHeight: 0 }}>
        <DiffEditor
          original={JSON.stringify(
            filterByFieldPaths(JSON.parse(orderText!), fieldPaths),
            null,
            2,
          )}
          modified={JSON.stringify(
            filterByFieldPaths(JSON.parse(syncText!), fieldPaths),
            null,
            2,
          )}
          language="json"
          options={{ readOnly: true, renderSideBySide: true }}
        />
      </Box>
    </Box>
  );
};

export default UpdateDiffView;
